import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import './PartnerOrganisations.css';
import CardComponent from "../card/CardComponent";
import LoaderCustomFixed from "../ConfirmationModal/LoaderCustomFixed";

const PartnerOrganisations = () => {
    const [partnerData, setPartnerData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const sliderRef = useRef(null);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllPartner`);
            const { data } = await response.json();
            setPartnerData(data.slice().reverse());
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        void fetchData();
    }, []);

    const getSliderSettings = () => ({
        dots: false,
        infinite: true,
        speed: 2000,
        slidesToShow: Math.max(1, Math.min(partnerData.length, 4)),
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1800,
        centerMode: partnerData.length >= 3,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: Math.min(partnerData.length, 3), dots: true } },
            { breakpoint: 600, settings: { slidesToShow: Math.min(partnerData.length, 2) } },
            { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
    });

    return (
        <div>
            {isLoading ? (
                <div style={{ minHeight: 400, minWidth: "100%", paddingTop: 50 }}>
                    <LoaderCustomFixed />
                </div>
            ) : (
                <div className="partner-organisations-container">
                    <Slider ref={sliderRef} {...getSliderSettings()}>
                        {partnerData.map((partner, index) => (
                            <div key={index} className="slide-item">
                                <CardComponent title={partner.fullName} tourl={partner.url} imgurl={partner.path.trim()} />
                            </div>
                        ))}
                    </Slider>
                </div>
            )}
        </div>
    );
};

export default PartnerOrganisations;
